import moment from 'moment';
import { API_DATE_FORMAT } from '../constants/dateFormats';
import {
  UPDATE_SELECTED_LOCALE,
  UPDATE_DATE_RANGE,
  RECEIVE_DASHBOARD,
  RECEIVE_CHART_DATA,
  RECEIVE_REPORT_DEFINITIONS,
  RECEIVE_ERRORS,
  DISMISS_ALERT,
} from '~src/actions/returnsDashboardAnalyticsActions';

const initialState = {
  alert: {
    show: false,
  },
  startDate: moment()
    .subtract(30, 'days')
    .format(API_DATE_FORMAT),
  endDate: moment()
    .subtract(1, 'days')
    .format(API_DATE_FORMAT),
  supportedLocales: [],
  selectedLocale: {
    locale: 'en_US',
  },
  chartData: {},
  dimensions: [],
  errors: [],
  dashboard: {},
  object: '',
  reports: {},
  reportDefinitions: {},
  reportsPayload: [],
};

export default (
  state = initialState,
  {
    type,
    meta,
    meta: { chartName } = {},
    payload: {
      startDate,
      endDate,
      selectedLocale,
      chartData,
      tableData,
      report_definitions: reportDefinitions,
      report_instances: reportInstances,
      dashboard_definitions: dashboard,
      supported_locales: supportedLocales,
      default_locale: defaultLocale,
    } = {},
  } = {},
) => {
  let object;
  switch (type) {
    case RECEIVE_CHART_DATA:
      return {
        ...state,
        chartData: {
          ...state.chartData,
          [chartName]: chartData,
        },
        tableData: {
          ...state.tableData,
          [chartName]: tableData,
        },
      };

    case RECEIVE_DASHBOARD:
      object = Object.keys(reportDefinitions)[0];
      return {
        ...state,
        dashboard,
        object,
        reports: {
          ...state.reports,
          ...reportInstances,
        },
        reportDefinitions,
        supportedLocales,
        selectedLocale: {
          locale: defaultLocale,
        },
      };

    case UPDATE_SELECTED_LOCALE:
      return {
        ...state,
        selectedLocale,
      };

    case UPDATE_DATE_RANGE:
      return {
        ...state,
        startDate,
        endDate,
      };

    case RECEIVE_REPORT_DEFINITIONS:
      return {
        ...state,
        object: reportDefinitions.id,
        reportDefinitions: {
          [reportDefinitions.id]: reportDefinitions,
        },
      };
    case RECEIVE_ERRORS:
      return {
        ...state,
        alert: {
          color: 'danger',
          show: true,
          text:
            typeof meta.error !== 'string'
              ? 'Unknown error occured.'
              : `${meta.error}.`,
        },
      };
    case DISMISS_ALERT:
      return {
        ...state,
        alert: initialState.alert,
      };

    default:
      return state;
  }
};
